import React, {
    useContext, useEffect, useMemo, useState,
} from 'react';
import { CookiesNotification } from 'app/components/ui/CookiesNotification/CookiesNotification';
import { getDishesFromBasketSections } from 'app/utils/dish';
import { isDesktop } from 'app/utils/resolution';
import { ConfigContext } from './ConfigProvider';
import { BasketContext } from './BasketProvider';

export const CookiesNotificationPromoCheckoutGuard = () => {
    const [isDesktopResolution, setIsDesktopResolution] = useState(isDesktop());
    const { isOpenBasketButtonHidden } = useContext(ConfigContext);
    const {
        basket,
    } = useContext(BasketContext);

    const basketDishes = useMemo(
        () => getDishesFromBasketSections(basket.sections),
        [basket.sections],
    );

    useEffect(
        () => {
            const handleResize = () => {
                setIsDesktopResolution(isDesktop());
            };
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        },
        [],
    );

    if (!isDesktopResolution || (!isOpenBasketButtonHidden && isOpenBasketButtonHidden !== undefined)
        || basketDishes.length > 0) {
        return null;
    }

    return <CookiesNotification pageClass="promoCheckout" />;
};
